import React, {useContext, useEffect, useReducer} from "react"
import {FirebaseContext} from 'components/common/Firebase'
import {AuthorizedUserContext} from 'components/common/AuthorizedUser'
import GigStore from './LiveGigs/GigStore'
import fetchGigs from './LiveGigs/fetchGigs'
import { transformGig } from './transformers'

const SavedGigsContext = React.createContext()

const mapJobs = jobs => {

}

const savedGigsReducer = (state, action) => {
    console.log('SavedGigs reducer:', action);

    const {type, payload} = action;

    switch (type) {
        case 'receiveGigs':
            // console.log('Before receive:', state, payload);
            const {entries, gigs} = payload;
            state = {
                ...state,
                entries: entries,
                savedGigs: gigs,
                savedGigsError: null
            };
            // console.log('After receive:', state);
            break;
        case 'addSavedGig':
            // console.log('Add saved gig:', payload.key, payload.entry);
            break;
        case 'removeSavedGig':
            // console.log('Remove saved gig:', payload.entry);
            break;
        case 'updateSavedGig':
            // console.log('Update saved gig:', payload.entry);
            break;
        default:
            console.log('Unknown action:', type)
    }

    return state
}

const SavedGigsProvider = (props) => {

    console.log('SavedGigsContext ----------')

    const firebase = useContext(FirebaseContext)
    const authorizedUser = useContext(AuthorizedUserContext)

    const saveGig = (gig) => {
        console.log('Saving gig:', gig)
        if (!hasGig(gig)) {
            gig.isSaved = true;
            const entryRef = firebase.gigs(authorizedUser.uid).push();
            const newEntry = gigStore.makeGigEntry(entryRef.key, gig, null, null);
            // console.log('Entry:', newEntry);
            const updates = gigStore.addGig(entryRef.key, gig);
            if (updates)
                firebase.gigs(authorizedUser.uid).update(updates);
            // entryRef.set(newData);
        }
    }

    const unsaveGig = async (gig) => {
        console.log('Unsaving gig:', gig)
        if (hasGig(gig.id)) {
            // console.log('Victim found')
            gig.isSaved = false; // TODO hack
            // firebase.gigs(authorizedUser.uid).child(gig.id).remove()
            const updates = gigStore.removeGig(gig.id);
            // console.log(updates)
            if (updates) {
                firebase.gigs(authorizedUser.uid).update(updates);
            }
        }
    }

    const initialState = {
        entries: [],
        savedGigs: null,
        savedGigsError: null,
    }

    const [state, dispatch] = useReducer(savedGigsReducer, initialState)

    console.log('Creating store', state)
    const gigStore = new GigStore(state.entries);

    const makeGig = gig => {
        gig.isSaved = true;
        return transformGig(gig)
    }

    const loadGigs = uid => {
        console.log('Fetching saved gigs for:', uid);
        const gigs = firebase.gigs(uid);
        gigs.on('value', snapshot => {
            console.log('New gigs from firebase')
            const entries = [];
            snapshot.forEach(doc => {
                const entry = doc.val();
                console.log(doc.key, '=>', entry)
                entry.id = doc.key
                entries.push(
                    gigStore.makeGigEntry(
                        doc.key,
                        entry.gig,
                        entry.next,
                        entry.prev)
                    );
            });
            console.log('Entries:', entries.map(e => ({...e})))
            const names = gigStore.mapGigs(entries).map(gig => gig.id)
            fetchGigs(names)
                .then(res => {
                    const gigs = res.data
                    // console.log('Returned from GTS:', gigs)
                    const nonNull = names.filter(name => gigs[name] ? true : false)
                    // console.log('Filtered:', nonNull)
                    const gigNames = nonNull.map(name => gigs[name])
                    // console.log('Names:', gigNames)
                    dispatch({
                        type: 'receiveGigs',
                        payload: {
                            entries: entries,
                            gigs: names
                                .filter(name => gigs[name] ? true : false )
                                .map(name => makeGig(gigs[name]))
                        }
                    });

                })
            // TODO Enable these to make some performance improvements.
            // gigs.off('value');
            // gigs.on('child_added', snapshot => dispatch({type: 'addSavedGig', payload: {key: snapshot.key, entry: snapshot.val()}}));
            // gigs.on('child_removed', snapshot => dispatch({type: 'removeSavedGig', payload: {key: snapshot.key, entry: snapshot.val()}}));
            // gigs.on('child_changed', snapshot => dispatch({type: 'updateSavedGig', payload: {key: snapshot.key, entry: snapshot.val()}}));
        })
    };

    const stopListeningToPersistedGigs = async () => {
        console.log('Stop listening')
        firebase.gigs(authorizedUser.uid).off()
    }

    useEffect(() => {
        loadGigs(authorizedUser.uid);
        // startListeningToPersistedGigs()
        return async () => {
            stopListeningToPersistedGigs()
        }
    }, [])

    const mapGigs = gigs => {
        return gigs.reduce((gigMap, gig) => {
            gigMap.set(gig.id, gig)
        }, new Map())
    }

    const rank = gigs => {
        const gigMap = mapGigs(gigs)
        return gigStore.gigs.map(gig => gigMap.get(gig.id))
    }

    const hasGig = gigId => gigStore.gigMap.has(gigId);

    const rankUp = gig => {
        console.log('Moving gig up:', gig)
        if (gig && hasGig(gig.id)) {
            const updates = gigStore.moveUp(gig.id)
            if (updates) {
                console.log('Updating:', updates)
                firebase.gigs(authorizedUser.uid).update(updates);
            }
        }
    }

    const rankDown = gig => {
        console.log('Moving gig down:', gig)
        if (gig && hasGig(gig.id)) {
            const updates = gigStore.moveDown(gig.id)
            if (updates) {
                console.log('Updating:', updates)
                firebase.gigs(authorizedUser.uid).update(updates);
            }
        }
    }

    const rankTop = gig => {
        console.log('Moving gig to top:', gig)
        if (gig && hasGig(gig.id)) {
            const updates = gigStore.moveToTop(gig.id)
            if (updates) {
                console.log('Updating:', updates)
                firebase.gigs(authorizedUser.uid).update(updates);
            }
        }
    }

    const rankBottom = gig => {
        console.log('Moving gig to bottom:', gig)
        if (gig && hasGig(gig.id)) {
            const updates = gigStore.moveToBottom(gig.id)
            if (updates) {
                console.log('Updating:', updates)
                firebase.gigs(authorizedUser.uid).update(updates);
            }
        }
    }

    const context = {
        state,
        saveGig,
        unsaveGig,
        hasGig,
        rankUp,
        rankDown,
        rankTop,
        rankBottom
    };

    return (
        <SavedGigsContext.Provider value={context}>
            {props.children}
        </SavedGigsContext.Provider>
    );
}
export {SavedGigsContext, SavedGigsProvider}